module.exports = __webpack_public_path__ + "static/media/title_board_l.24e2db51.svg";